import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-dc09177a")

_pushScopeId("data-v-dc09177a")
const _hoisted_1 = /*#__PURE__*/_createVNode("i", { class: "el-icon-user-solid" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("i", { class: "el-icon-plus" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_table = _resolveComponent("el-table")
  const _component_UserCreationForm = _resolveComponent("UserCreationForm")
  const _component_UserUpdateForm = _resolveComponent("UserUpdateForm")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_el_row, null, {
      default: _withId(() => [
        _createVNode(_component_el_col, {
          xs: 12,
          sm: 12,
          md: 20
        }, {
          default: _withId(() => [
            _createVNode("h2", null, [
              _hoisted_1,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("menu.users")), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          class: "create-user",
          xs: 12,
          sm: 12,
          md: 4
        }, {
          default: _withId(() => [
            _createVNode(_component_el_button, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.userCreationDialogVisible = true)),
              size: "small",
              type: "success"
            }, {
              default: _withId(() => [
                _hoisted_2,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("users.table.actions.add")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _withDirectives(_createVNode(_component_el_table, {
      data: 
      _ctx.getUsers.filter(
        (data) =>
          !_ctx.search || data.email.toLowerCase().includes(_ctx.search.toLowerCase())
      )
    
    }, {
      default: _withId(() => [
        _createVNode(_component_el_table_column, {
          sortable: "",
          prop: "email",
          label: _ctx.$t('users.table.headers.email')
        }, null, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          sortable: "",
          prop: "displayName",
          label: _ctx.$t('users.table.headers.name')
        }, null, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          sortable: "",
          prop: "enabled",
          label: _ctx.$t('users.table.headers.in_use'),
          formatter: _ctx.isInUse
        }, null, 8, ["label", "formatter"]),
        _createVNode(_component_el_table_column, {
          selectedUser: "",
          sortable: "",
          prop: "customClaims.role",
          label: _ctx.$t('users.table.headers.role'),
          formatter: _ctx.convertRole
        }, null, 8, ["label", "formatter"]),
        _createVNode(_component_el_table_column, { align: "right" }, {
          header: _withId(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.search,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.search = $event)),
              size: "mini",
              placeholder: _ctx.$t('users.table.headers.search')
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          default: _withId((scope) => [
            _createVNode(_component_el_button, {
              size: "mini",
              onClick: ($event: any) => (_ctx.handleEdit(scope.row))
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("users.table.actions.edit")), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_el_popconfirm, {
              onConfirm: ($event: any) => (_ctx.handleReset(scope.row)),
              "confirm-button-text": _ctx.$t('general.yes'),
              "cancel-button-text": _ctx.$t('general.no'),
              title: _ctx.$t('users.messages.alerts.reset')
            }, {
              reference: _withId(() => [
                _createVNode(_component_el_button, {
                  disabled: _ctx.isCurrentUser(scope.row.uid),
                  size: "mini",
                  type: "info",
                  plain: ""
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("users.table.actions.reset_password")), 1)
                  ]),
                  _: 2
                }, 1032, ["disabled"])
              ]),
              _: 2
            }, 1032, ["onConfirm", "confirm-button-text", "cancel-button-text", "title"]),
            _createVNode(_component_el_popconfirm, {
              onConfirm: ($event: any) => (_ctx.handleDelete(scope.row)),
              "confirm-button-text": _ctx.$t('general.yes'),
              "cancel-button-text": _ctx.$t('general.no'),
              title: _ctx.$t('users.messages.alerts.confirm')
            }, {
              reference: _withId(() => [
                _createVNode(_component_el_button, {
                  disabled: _ctx.isCurrentUser(scope.row.uid),
                  size: "mini",
                  type: "danger"
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("users.table.actions.delete")), 1)
                  ]),
                  _: 2
                }, 1032, ["disabled"])
              ]),
              _: 2
            }, 1032, ["onConfirm", "confirm-button-text", "cancel-button-text", "title"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode(_component_UserCreationForm, {
      onUserSuccess: _ctx.handleUserOperationSuccess,
      onUserError: _ctx.handleUserOperationError,
      onDialogClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.userCreationDialogVisible = false)),
      visible: _ctx.userCreationDialogVisible
    }, null, 8, ["onUserSuccess", "onUserError", "visible"]),
    _createVNode(_component_UserUpdateForm, {
      key: _ctx.selectedUser.uid,
      "user-email": _ctx.selectedUser.email,
      "user-display-name": _ctx.selectedUser.displayName,
      "user-enabled": _ctx.selectedUser.enabled,
      "user-custom-claims": _ctx.selectedUser.customClaims,
      "user-uid": _ctx.selectedUser.uid,
      "is-current-user": _ctx.isCurrentUser(_ctx.selectedUser.uid),
      onUserSuccess: _ctx.handleUserOperationSuccess,
      onUserError: _ctx.handleUserOperationError,
      onDialogClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.userUpdateDialogVisible = false)),
      visible: _ctx.userUpdateDialogVisible
    }, null, 8, ["user-email", "user-display-name", "user-enabled", "user-custom-claims", "user-uid", "is-current-user", "onUserSuccess", "onUserError", "visible"])
  ], 64))
})